import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import Config from '../../config';
import type { Job } from '../../menu/jobsMenu/types';
import { METHODS } from '../constants';
import { fetchJobs, optimisticUpdateMarkJobNotificationsAsSeen } from '../jim/store/actions';
import { useCustomMutation } from './index';

export const useMarkJimNotificationsAsSeen = () => {
  const dispatch = useDispatch();

  const refreshJobs = useCallback(() => {
    dispatch(fetchJobs());
  }, [dispatch]);

  const onMutate = useCallback((jobIds: Job['jobId'][]) => {
    dispatch(optimisticUpdateMarkJobNotificationsAsSeen(jobIds));
  }, [dispatch]);

  return useCustomMutation({
    handleData: (jobIds: Job['jobId'][]) => ({
      url: Config.endpoints.MARK_NOTIFICATIONS_AS_SEEN,
      method: METHODS.POST,
      body: jobIds,
    }),
    errorMessage: '',
    successMessage: '',
    invalidateKey: [],
    onSuccess: refreshJobs,
    onMutate,
  });
};

type useDeleteJobResultsParams = {
  jobId: string,
  successMessage: string,
  errorMessage: string,
}
export const useDeleteJobResults = ({
  jobId,
  successMessage,
  errorMessage,
}: useDeleteJobResultsParams) => useCustomMutation({
  handleData: () => ({
    url: Config.endpoints.DELETE_JOB_RESULTS.replace(':jobId', jobId),
    method: METHODS.DELETE,
  }),
  errorMessage,
  successMessage,
  invalidateKey: [],
});
